var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.75C10.7573 5.75 9.75 6.75736 9.75 8C9.75 9.24264 10.7573 10.25 12 10.25C13.2427 10.25 14.25 9.24264 14.25 8C14.25 6.75736 13.2427 5.75 12 5.75ZM8.25 8C8.25 5.92894 9.92888 4.25 12 4.25C14.0711 4.25 15.75 5.92894 15.75 8C15.75 10.0711 14.0711 11.75 12 11.75C9.92888 11.75 8.25 10.0711 8.25 8Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 4C15.25 3.58579 15.5858 3.25 16 3.25C18.0711 3.25 19.75 4.92894 19.75 7C19.75 8.53001 18.8338 9.84441 17.5232 10.4275C17.1447 10.5959 16.7014 10.4256 16.5331 10.0472C16.3647 9.66873 16.535 9.22544 16.9134 9.05706C17.7024 8.70605 18.25 7.91617 18.25 7C18.25 5.75736 17.2427 4.75 16 4.75C15.5858 4.75 15.25 4.41421 15.25 4Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 18C5.25 15.3767 7.37664 13.25 10 13.25H14C16.6233 13.25 18.75 15.3767 18.75 18V20C18.75 20.4142 18.4142 20.75 18 20.75H6C5.58579 20.75 5.25 20.4142 5.25 20V18ZM10 14.75C8.20508 14.75 6.75 16.2051 6.75 18V19.25H17.25V18C17.25 16.2051 15.7949 14.75 14 14.75H10Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 13C17.25 12.5858 17.5858 12.25 18 12.25C20.6233 12.25 22.75 14.3767 22.75 17V19C22.75 19.4142 22.4142 19.75 22 19.75H20.5C20.0858 19.75 19.75 19.4142 19.75 19C19.75 18.5858 20.0858 18.25 20.5 18.25H21.25V17C21.25 15.2051 19.7949 13.75 18 13.75C17.5858 13.75 17.25 13.4142 17.25 13Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 7C4.25 4.92894 5.92894 3.25 8 3.25C8.41421 3.25 8.75 3.58579 8.75 4C8.75 4.41421 8.41421 4.75 8 4.75C6.75736 4.75 5.75 5.75736 5.75 7C5.75 7.91616 6.29764 8.70605 7.08656 9.05707C7.46501 9.22545 7.6353 9.66874 7.46691 10.0472C7.29853 10.4256 6.85524 10.5959 6.4768 10.4275C5.16622 9.84441 4.25 8.53002 4.25 7Z",
    fill: "#76B72A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 17C1.25 14.3767 3.37664 12.25 6 12.25C6.41421 12.25 6.75 12.5858 6.75 13C6.75 13.4142 6.41421 13.75 6 13.75C4.20508 13.75 2.75 15.2051 2.75 17V18.25H3.5C3.91421 18.25 4.25 18.5858 4.25 19C4.25 19.4142 3.91421 19.75 3.5 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19V17Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserGroup);
export default __webpack_public_path__ + "static/media/ic-user-group.ba675fab1c8055303e88bb0ce91fbb55.svg";
export { ForwardRef as ReactComponent };